import script from "./FenFa.vue?vue&type=script&setup=true&lang=js"
export * from "./FenFa.vue?vue&type=script&setup=true&lang=js"

import "./FenFa.vue?vue&type=style&index=0&id=ea475f4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea475f4e"]])

export default __exports__